<div class="modal-overlay">
  <div class="modal-container" (click)="$event.stopPropagation()">
    <div class="modal-content">
      <div class="alert-icon">
        <svg width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
          <circle cx="32" cy="32" r="28" fill="#FF9800" stroke="#FF9800" stroke-width="2"/>
          <path d="M32 20V36M32 44V46" stroke="white" stroke-width="3" stroke-linecap="round"/>
        </svg>
      </div>

      <h2 class="modal-title">Tu sesión está por expirar</h2>

      <p class="modal-message">
        Tu sesión se cerrará en <strong>{{ formattedTime }}</strong> por expiracion de token. ¿Deseas continuar con tu sesión?
      </p>

      <div class="modal-actions">
        <button 
          class="btn btn-primary" 
          (click)="onContinue()"
          type="button">
          Continuar sesión
        </button>
        <button 
          class="btn btn-secondary" 
          (click)="onClose()"
          type="button">
          Cerrar sesión
        </button>
      </div>
    </div>
  </div>
</div>
